import { TItemWithIssues } from './types';

// Mock data for top cards
const TOP_CARDS_MOCK_DATA = {
  submissionReadiness: 78, // in percentage
  totalDocuments: 120,
  criticalIssues: 17,
  criticalIssuesLess: 7,
  openApprovals: 2,
  openApprovalsMore: 2,
};

// Mock data for table
const FILES_WITH_ISSUES_MOCK_DATA: TItemWithIssues[] = [
  {
    _id: '1',
    name: 'Risk Analysis Report',
    stats: {} as any,
    type: 'DOCUMENT',
    hasDraft: false,
    numErrors: 5,
    accessRight: 300,
    accessRightAllowFrozen: 300,
    isFrozen: false,
    isBlock: false,
    isTemplate: false,
    unresolvedIssues: 5,
    errorCategories: ['Completeness', 'Causality', 'Reference', '+2'],
    latestVersion: 'v5.2',
    approvedVersion: 'v5.0',
    path: [],
  },
  {
    _id: '2',
    name: 'Clinical Evaluation Report (CER)',
    stats: {} as any,
    type: 'DOCUMENT',
    hasDraft: false,
    numErrors: 3,
    accessRight: 300,
    accessRightAllowFrozen: 300,
    isFrozen: false,
    isBlock: false,
    isTemplate: false,
    unresolvedIssues: 5,
    errorCategories: ['Completeness', 'Missing approval', '+1'],
    latestVersion: 'Draft',
    approvedVersion: 'v3.0',
    path: [],
  },
  {
    _id: '3',
    name: 'Intended Use and Intended Purpose',
    stats: {} as any,
    type: 'DOCUMENT',
    hasDraft: false,
    numErrors: 2,
    accessRight: 300,
    accessRightAllowFrozen: 300,
    isFrozen: false,
    isBlock: false,
    isTemplate: false,
    unresolvedIssues: 3,
    errorCategories: ['Causality', 'Unresolved comment'],
    latestVersion: 'v4.0',
    approvedVersion: 'v4.0',
    path: [],
  },
  {
    _id: '67b23175ac8bf5af093f489b',
    name: 'Device Description & Specification',
    stats: {} as any,
    type: 'DOCUMENT',
    hasDraft: false,
    numErrors: 1,
    accessRight: 300,
    accessRightAllowFrozen: 300,
    isFrozen: false,
    isBlock: false,
    isTemplate: false,
    unresolvedIssues: 1,
    errorCategories: ['Reference'],
    latestVersion: 'v2.0',
    approvedVersion: 'v2.0',
    path: [],
  },
  {
    _id: '5',
    name: 'General Safety and Performance Requirements',
    stats: {} as any,
    type: 'DOCUMENT',
    hasDraft: false,
    numErrors: 5,
    accessRight: 300,
    accessRightAllowFrozen: 300,
    isFrozen: false,
    isBlock: false,
    isTemplate: false,
    unresolvedIssues: 1,
    errorCategories: ['Guidance revision'],
    latestVersion: 'v3.0',
    approvedVersion: 'v3.0',
    path: [],
  },
  {
    _id: '6',
    name: 'GSPR Checklist',
    stats: {} as any,
    type: 'FILE',
    hasDraft: false,
    numErrors: 3,
    accessRight: 300,
    accessRightAllowFrozen: 300,
    isFrozen: false,
    isBlock: false,
    isTemplate: false,
    latestMimetype: 'application/vnd.ms-excel',
    unresolvedIssues: 1,
    errorCategories: ['Unresolved comment'],
    latestVersion: 'v6.0',
    approvedVersion: 'v6.0',
    path: [],
  },
  {
    _id: '7',
    name: 'Instruction for Use (Ivexis)',
    stats: {} as any,
    type: 'FILE',
    hasDraft: false,
    numErrors: 2,
    accessRight: 300,
    accessRightAllowFrozen: 300,
    isFrozen: false,
    isBlock: false,
    isTemplate: false,
    unresolvedIssues: 1,
    latestMimetype: 'application/pdf',
    errorCategories: ['Missing approval'],
    latestVersion: 'Draft',
    approvedVersion: 'v5.0',
    path: [],
  },
];

const HEADER_CELLS = [
  { title: 'Document name', width: undefined },
  { title: 'Unresolved issues', width: '15rem', isCentralized: true },
  { title: 'Error categories', width: undefined },
  { title: 'Latest', width: '7.5rem', isCentralized: true },
  { title: 'Approved', width: '7.5rem', isCentralized: true },
];

export { TOP_CARDS_MOCK_DATA, FILES_WITH_ISSUES_MOCK_DATA, HEADER_CELLS };
